<dgx-skill-standards-segment-status-indicator
  [status]="status"
  [count]="count"
></dgx-skill-standards-segment-status-indicator>
